<div class="document-upload">
  <h3 class="document-upload-headline">
    {{ 'guidedCourseCreation.document.label' | translate }}
    <app-tooltip-button
      [tooltipKey]="'tooltips.guidedCourseCreation.document'"
    ></app-tooltip-button>
  </h3>

  <div class="document-upload-actions">
    <input
      #fileInput
      id="gcc-document-upload"
      name="document"
      type="file"
      class="document-upload-input"
      [accept]="acceptedFileTypes"
      (change)="onFileSelected($event)"
    />
    <button
      type="button"
      class="document-upload-button"
      [disabled]="isUploadDisabled()"
      (click)="openFilePicker(fileInput)"
    >
      <mat-icon class="size-m">cloud_upload</mat-icon>
      <span>{{ 'guidedCourseCreation.document.selectFile' | translate }}</span>
    </button>
    <span class="document-upload-formats">
      {{
        'guidedCourseCreation.document.supportedFormats'
          | translate: messageParams
      }}
    </span>
  </div>

  @if (selectedFile(); as file) {
    <div class="document-upload-file">
      <div class="document-upload-file-row">
        @if (isUploading()) {
          <app-hourglass-spinner></app-hourglass-spinner>
        } @else if (hasError()) {
          <mat-icon class="size-m document-upload-file-icon--error"
            >cancel</mat-icon
          >
        } @else {
          <mat-icon class="size-m document-upload-file-icon--success"
            >check_circle</mat-icon
          >
        }

        <span class="document-upload-file-name">{{ file.name }}</span>

        @if (isUploading()) {
          <span class="document-upload-file-meta">
            {{ 'guidedCourseCreation.document.analysing' | translate }}
          </span>
        } @else if (pageCount(); as pages) {
          <span class="document-upload-file-meta">
            {{
              'guidedCourseCreation.document.pages'
                | translate: { count: pages }
            }}
          </span>
        }

        <button
          type="button"
          class="document-upload-file-remove"
          [attr.aria-label]="'guidedCourseCreation.document.remove' | translate"
          (click)="onRemove()"
        >
          <mat-icon class="size-m">delete</mat-icon>
        </button>
      </div>

      @if (hasError()) {
        <p class="document-upload-file-error">
          {{ messageKey() | translate: messageParams }}
        </p>
      }
    </div>
  }

  @if (suggestedTopics().length) {
    <h4 class="document-upload-topics-headline">
      {{ 'guidedCourseCreation.document.suggestions.label' | translate }}
      <app-tooltip-button
        [tooltipKey]="'tooltips.guidedCourseCreation.documentTopics'"
      ></app-tooltip-button>
    </h4>
    <div class="document-upload-topics">
      @for (chip of topicChips(); track chip.topic) {
        <app-suggestion-chip
          [label]="chip.topic"
          [disabled]="chip.used"
          (selected)="onSelectTopic(chip.topic)"
        />
      }
    </div>
  }
</div>
